import React from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

import Card from "../../../../components/Card";
import { useLocalization } from "../../../../../context/LocalizeContextProvider";
import InputField from "../../../../components/InputField";
import Button from "../../../../components/Button";
import Table from "../../../../components/Table";
import { formatNumberWithCurrency } from "../../../../../utils/utils";

export default function ListDepositComponents({
  handleChangeFilter = () => undefined,
  handleClearFilter = () => undefined,
  handleClickFilter = () => undefined,
  handlePagination = () => undefined,
  handleChangeSizePerPage = () => undefined,
  isLoading = false,
  filterDeposit = {},
  dataPatientDeposit = [],
  activePage = 0,
  totalPage = 0,
  totalEntries = 0,
  sizePerPage = 10,
}) {
  const localize = useLocalization();

  const columns = [
    {
      label: localize.getText("namePatient"),
      key: "patient_name",
    },
    {
      label: localize.getText("identityNumber"),
      key: "identity_number",
    },
    {
      label: localize.getText("balance"),
      key: "balance",
    },
    {
      label: localize.getText("phoneNumber"),
      key: "phone_number",
    },
  ];

  return (
    <div>
      <Card title={localize.getText("filterDataDepositPatient")}>
        <Row style={{ rowGap: 18 }}>
          <Col md={4}>
            <InputField
              label={localize.getText("identityNumber")}
              placeholder={localize.getText("placeholderField", {
                fieldName: localize.getText("identityNumber"),
              })}
              onChange={(value) => handleChangeFilter("identity_number", value)}
              value={filterDeposit?.identity_number || ""}
              fullWidth
              isBorder
            />
          </Col>
          <Col md={4}>
            <InputField
              label={localize.getText("name")}
              placeholder={localize.getText("placeholderField", {
                fieldName: localize.getText("name"),
              })}
              onChange={(value) => handleChangeFilter("name", value)}
              value={filterDeposit?.name || ""}
              fullWidth
              isBorder
            />
          </Col>
          <Col md={4}>
            <InputField
              label={localize.getText("phoneNumber")}
              placeholder={localize.getText("placeholderField", {
                fieldName: localize.getText("phoneNumber"),
              })}
              onChange={(value) => handleChangeFilter("phone_number", value)}
              value={filterDeposit?.phone_number || ""}
              fullWidth
              isBorder
            />
          </Col>
        </Row>
        <div
          className="d-flex gap-2 justify-content-end"
          style={{ marginTop: "24px" }}
        >
          <Button
            label={localize.getText("reset")}
            variant="danger"
            onClick={handleClearFilter}
          />
          <Button
            label={localize.getText("search")}
            onClick={handleClickFilter}
          />
        </div>
      </Card>

      <Card
        header={
          <div className="d-flex justify-content-end w-100">
            <Link to="/patient-deposit/add-deposit">
              <Button
                label={localize.getText("addDeposit")}
                variant="primary"
              />
            </Link>
          </div>
        }
      >
        <Table
          columns={columns}
          loading={isLoading}
          activePage={activePage}
          totalPage={totalPage}
          totalShow={dataPatientDeposit?.length || 0}
          totalEntries={totalEntries}
          sizePerPage={sizePerPage}
          handlePagination={handlePagination}
          handleSizePerPage={handleChangeSizePerPage}
        >
          {dataPatientDeposit.map((item, index) => (
            <tr key={index}>
              <td>{item?.patient_name}</td>
              <td>{item?.identity_number}</td>
              <td>{formatNumberWithCurrency(item?.balance || 0)}</td>
              <td>{item?.phone_number || "-"}</td>
            </tr>
          ))}
        </Table>
      </Card>
    </div>
  );
}
